import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppContextService } from '../services/app-context.service';
import { TranslateModule } from '../services/translate/translate.module';
import { CoreModule } from '../core/core.module';
import { ReactiveFormsModule } from '@angular/forms';
import { RequiredActionComponent } from './required-action.component';
import { MissingAcceptedComponent } from './documentation/missing-accepted.component';
import { RequiredActionRoutingModule } from './required-action-routing.module';
import { UserLoginRoleSelectionComponent } from './users/user-login-role-selection/user-login-role-selection.component';

@NgModule({
	imports: [CommonModule, FormsModule, CoreModule, RequiredActionRoutingModule, TranslateModule, ReactiveFormsModule],
	providers: [AppContextService],
	declarations: [RequiredActionComponent, MissingAcceptedComponent, UserLoginRoleSelectionComponent],
})
export class RequiredActionModule {}
